import * as React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PageType } from '@type/component-data-types'

// memo: ページロード時にサイトロゴのSVGが大きく表示される事象への対応。
// styleをinlineで記述することで、CSSファイル読み込み前でも大きく表示されないようにする
const siteLogoStyle = {
  maxWidth: '12rem',
}

type Props = {
  pageType?: PageType
}

// markup
const SiteLogo = (props: Props): React.JSX.Element => {
  const isTop = props.pageType === 'index'

  const afbLogoImagePath = useStaticQuery(graphql`
    query getLogoImage {
      file(name: { eq: "logo_afb_b" }) {
        publicURL
      }
    }
  `)

  if (isTop) {
    return (
      <>
        <hgroup className="mb-0">
          <h1 className="siteLogo__logo">
            <img
              src={afbLogoImagePath.file.publicURL}
              alt="afb"
              style={siteLogoStyle}
              data-e2e-test="siteLogo"
              width="300"
              height="138"
            />
          </h1>
          <p className="siteLogo__title">アフィリエイトプラットフォームafb</p>
        </hgroup>
      </>
    )
  } else {
    return (
      <>
        <div className="mb-0">
          <p className="siteLogo__logo">
            <img
              src={afbLogoImagePath.file.publicURL}
              alt="afb"
              style={siteLogoStyle}
              data-e2e-test="siteLogo"
              width="300"
              height="138"
            />
          </p>
          <p className="siteLogo__title">アフィリエイトプラットフォームafb</p>
        </div>
      </>
    )
  }
}

export default SiteLogo
